import i18n from '../i18n';

const handleErrorResponse = (error) => {
  let response = {
    message: i18n.t("server_not_available"),
    status: "error",
  };

  if (error.response) {
    const responseData = error.response.data;
    if (responseData?.esito === 2) {
      response.message = responseData.message;
      response.status = "warning";
    } else if (responseData?.message) {
      response.message = responseData.message;
    } else {
      response.message = handleErrorStatus(error.response.status);
    }
  } else if (error.length > 0) {
    response.message = `${error}`;
  }

  return response;
};

const handleErrorStatus = (status) => {
  switch (status) {
    case 401:
    case 403:
      return i18n.t("not_authorized");
    case 400:
      return i18n.t("incorrect_data");
    default:
      return i18n.t("server_not_available");
  }
};

export default handleErrorResponse;

